import React from "react";
import { Box } from "@mui/material";
import { ScheduleOutlined } from "@mui/icons-material";
import { dt } from "../../../shared/themes/redesignTokens";

// ═══════════════════════════════════════════════════════════════
//  TimeInStageRow — clock icon + monospace time-ago display
//  Used in the card context panel to show time-in-current-stage.
// ═══════════════════════════════════════════════════════════════

interface TimeInStageRowProps {
  /** i18n label (e.g. "Sent", "Confirmed") */
  label: string;
  /** Human-readable time-ago string (e.g. "3h ago", "Feb 24") */
  timeAgo: string;
}

const TimeInStageRow: React.FC<TimeInStageRowProps> = ({ label, timeAgo }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
    <ScheduleOutlined sx={{ fontSize: "14px", color: dt.textMuted }} />
    <Box
      sx={{
        fontSize: "12px",
        fontFamily: dt.fontMono,
        color: dt.textMuted,
        fontWeight: 500,
      }}
    >
      {label} {timeAgo}
    </Box>
  </Box>
);

export default TimeInStageRow;
